import type { Entry, Round } from '@h2h/shared';
import type { PlayerRoundPicks } from '../../lib/api';

/** Minimal entry shape so profile cycling picks reuse buildStageLadder / StakeLadder. */
export function buildProfileCyclingEntry(player: PlayerRoundPicks, round: Round): Entry | null {
  if (!player.duelPicks.length) return null;
  return {
    userId: player.userId,
    leagueId: '',
    roundId: round.roundId,
    groupId: '',
    tier: 0,
    duelPicks: player.duelPicks.map((p) => ({
      duelId: p.duelId,
      pick: p.pick,
      confidenceWeight: p.confidenceWeight
    })),
    predictions: [],
    submittedAt: 0
  };
}
